import { Navigate, useLocation } from "react-router-dom";
import { useIsAuthenticated } from "@azure/msal-react";
import { msalInstance } from "@/core/auth/msalInstance";
import { loginRequest } from "@/config/authConfig";
import "./LoginPage.css";

const LoginPage = () => {
    const location = useLocation();
    // Restore the page the user originally requested after successful login
    const from = (location.state as { from?: string })?.from ?? "/";
    const isAuthenticated = useIsAuthenticated();
    if (isAuthenticated) return <Navigate to={from} replace />;

    const handleLogin = () => {
        msalInstance.loginRedirect({
            ...loginRequest,
            redirectStartPage: window.location.origin + from,
        }).catch((e) => console.error("Login redirect failed:", e));
    };

    return (
        <div className="login-page">
            <div className="login-card">
                <div className="login-logo">
                    <span className="login-logo-icon">💹</span>
                </div>
                <h1 className="login-title">MoneyMaker</h1>
                <p className="login-subtitle">Energi Danmark Strategy Platform</p>
                <button className="login-button" onClick={handleLogin}>
                    <svg className="ms-logo" viewBox="0 0 23 23" xmlns="http://www.w3.org/2000/svg">
                        <rect x="1" y="1" width="10" height="10" fill="var(--ms-red)" />
                        <rect x="12" y="1" width="10" height="10" fill="var(--ms-green)" />
                        <rect x="1" y="12" width="10" height="10" fill="var(--ms-blue)" />
                        <rect x="12" y="12" width="10" height="10" fill="var(--ms-yellow)" />
                    </svg>
                    Sign in with Microsoft
                </button>
                <p className="login-hint">Use your Energi Danmark account</p>
            </div>
        </div>
    );
};

export default LoginPage;
